"use strict";

var React = require('react');
var ReactForms = require('react-forms');
var Immutable = require('immutable');

var settings = require('ofs/settings');
var i18n = require('ofs/i18n');
var gettext = i18n.gettext;
var interpolate = i18n.interpolate;

var SelectOne = require('ofs/forms/inputs/simple-choice');
var Scalar = require('ofs/forms/scalars/Scalar');
var scalars = require('ofs/forms/scalars');

var FormElement = ReactForms.Element;
var Row = require('ofs/forms/layout/row');
var Column = require('ofs/forms/layout/column');
var Group = require('ofs/forms/layout/group');

var messages = {
  START_DATE_LABEL: gettext('Arrival date'),
  START_DATE_PLACEHOLDER: gettext('Select an arrival date'),
  END_DATE_LABEL: gettext('Departure date'),
  END_DATE_PLACEHOLDER: gettext('Select a departure date'),
  FLEXIBLE_DATES_LABEL: gettext('My dates are flexible'),
  LOCATION_LABEL: gettext('Location'),
  BUDGET_LABEL: gettext('Approximate budget (per night)'),
  ADULTS_LABEL: gettext('Adults'),
  CHILDREN_LABEL: gettext('Children'),
  CHILDREN_HINT: gettext('Age 4-12'),
  TODDLERS_LABEL: gettext('Toddlers'),
  TODDLERS_HINT: gettext('Age 1-3'),
  BABIES_LABEL: gettext('Babies'),
  BABIES_HINT: gettext('Under 1'),
  FOOTER_MESSAGE: gettext('Alternatively, contact our <b>Reservations team</b> directly'),
  CONTACT_MESSAGE: gettext('<strong>%(phone_number)s</strong> or <a href="%(email_url)s">%(email_address)s</a>')
};

var adultOptions = Immutable.Range(1, 17).map(function(i) { return {value: i, name: i}; }).toJS();
var guestOptions = Immutable.Range(0, 17).map(function(i) { return {value: i, name: i}; }).toJS();

var locationOptions = [
  {value: 'LON', name: 'London'},
  {value: 'LAX', name: 'Los Angeles'},
  {value: 'NYC', name: 'New York'},
  {value: 'PAR', name: 'Paris'},
  {value: 'OTHER', name: 'Other'},
];


var mapping = function(defaultValues) {
  const defaultMaxBudget = defaultValues.get('budgetMax', null);

  return {
    'start_date': scalars.DateScalar({
      label: messages.START_DATE_LABEL,
      defaultValue: defaultValues.get('startDate', null),
      placeholder: messages.START_DATE_PLACEHOLDER
    }),
    'end_date': scalars.DateScalar({
      label: messages.END_DATE_LABEL,
      defaultValue: defaultValues.get('endDate', null),
      placeholder: messages.END_DATE_PLACEHOLDER
    }),
    'flexible_dates': Scalar({
      type: 'bool',
      label: messages.FLEXIBLE_DATES_LABEL
    }),
    'location': Scalar({
      type: 'string',
      defaultValue: defaultValues.get('cityCode') || 'LON',
      input: <SelectOne options={locationOptions} />,
      label: messages.LOCATION_LABEL
    }),
    'budget': Scalar({
      type: 'price',
      // string should have a pipe separating currency and maxBudget.
      defaultValue: defaultMaxBudget ? defaultValues.get('currency') + '|' + defaultMaxBudget : null,
      label: messages.BUDGET_LABEL
    }),
    'adults': Scalar({
      type: 'number',
      defaultValue: parseInt(defaultValues.get('numberOfGuests')) || 1,
      input: <SelectOne options={adultOptions} />,
      label: messages.ADULTS_LABEL
    }),
    'children': Scalar({
      type: 'number',
      defaultValue: 0,
      input: <SelectOne options={guestOptions} />,
      label: messages.CHILDREN_LABEL,
      hint: messages.CHILDREN_HINT
    }),
    'toddlers': Scalar({
      type: 'number',
      defaultValue: 0,
      input: <SelectOne options={guestOptions} />,
      label: messages.TODDLERS_LABEL,
      hint: messages.TODDLERS_HINT
    }),
    'babies': Scalar({
      type: 'number',
      defaultValue: 0,
      input: <SelectOne options={guestOptions} />,
      label: messages.BABIES_LABEL,
      hint: messages.BABIES_HINT
    })
  };
};

var layout = function(value) {
  return [
    <Group>
      <Row>
        <Column size="half"><FormElement className="bdd-enquire-modal-field-start-date" value={value.get('start_date')} /></Column>
        <Column size="half"><FormElement className="bdd-enquire-modal-field-end-date" value={value.get('end_date')} /></Column>
      </Row>
      <Row>
        <Column size="full"><FormElement className="bdd-enquire-modal-field-flexible-dates" value={value.get('flexible_dates')} /></Column>
      </Row>
    </Group>,
    <Group>
      <Row>
        <Column size="half"><FormElement className="bdd-enquire-modal-field-location" value={value.get('location')} /></Column>
        <Column size="half"><FormElement className="bdd-enquire-modal-field-budget" value={value.get('budget')} /></Column>
      </Row>
    </Group>,
    <Group>
      <Row>
        <Column size="quarter"><FormElement className="bdd-enquire-modal-field-adults" value={value.get('adults')} /></Column>
        <Column size="quarter"><FormElement className="bdd-enquire-modal-field-children" value={value.get('children')} /></Column>
        <Column size="quarter"><FormElement className="bdd-enquire-modal-field-toddlers" value={value.get('toddlers')} /></Column>
        <Column size="quarter"><FormElement className="bdd-enquire-modal-field-babies" value={value.get('babies')} /></Column>
      </Row>
    </Group>
  ];
};

var Footer = React.createClass({
  render() {
    var contact = null;
    var contactMsg = null;
    if (this.props.cityCode !== "" && this.props.cityCode !== null) {
      contact = settings.cities[this.props.cityCode].contact;
      contactMsg = interpolate(messages.CONTACT_MESSAGE, {
        'phone_number': contact['reservations']['phone'],
        'email_url': `mailto:${ contact['reservations']['email'] }`,
        'email_address': contact['reservations']['email']
      }, true);
    }

    return (
      <div className="ofs-InfoPanel u-text-center">
        <p dangerouslySetInnerHTML={{__html: messages.FOOTER_MESSAGE}} />
        <p dangerouslySetInnerHTML={{__html: contactMsg}} />
      </div>
    );
  }
});

module.exports = {mapping, layout, Footer};



/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/components/contact/mappings/search.jsx
 **/